import ApiClient from "@/api/ApiClient";
import cookiesHandler from "@/composables/cookiesHandler";

class BudgetService {
  #prefixUrl = 'api/budget/';

  constructor() {
    this.api = new ApiClient(this.#prefixUrl);
  }

  /**
   * Tries to login
   * @param Budget budgetObj 
   * @returns {Budget|Null}
   */
  async saveBudget(budgetObj = {}, simple = true) {
    const relativeUrl = simple ? 'simple' : 'advanced';
    const response = await this.api.executeRequest(relativeUrl, budgetObj, this.api.methods.POST);

    if(response.success()){
      const id = response.getContent().id ?? '';
      cookiesHandler.setEncryptedCookie('BD_I', id);
      return id;
    }

    return false;
  }

  async getBudget() {
    const response = await this.api.executeRequest('/', {}, this.api.methods.GET);

    return response;
  }
}

export default new BudgetService();
